"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _lodash = _interopRequireDefault(require("lodash.memoize")),
    _lodash2 = _interopRequireDefault(require("lodash.omit")),
    _isURL = _interopRequireDefault(require("validator/lib/isURL")),
    _uiKit = require("@devsta/ui-kit"),
    _memoizeOne = _interopRequireDefault(require("memoize-one")),
    _SocialInputs = _interopRequireDefault(require("./SocialInputs"));

require("../styles/_link-social-button.scss"), require("../styles/_highlighted-icons.scss");

function _createSuper(a) {
  var b = _isNativeReflectConstruct();

  return function () {
    var c,
        d = (0, _getPrototypeOf2["default"])(a);

    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

var isValidURL = function isValidURL(a) {
  return !a || (0, _isURL["default"])(a);
};

function getInitialState(a) {
  var b = a.socialProfiles,
      c = b.website,
      d = b.facebook,
      e = b.twitter,
      f = b.linkedIn,
      g = b.other;
  return {
    website: {
      value: c || "",
      valid: isValidURL(c)
    },
    facebook: {
      value: d || "",
      valid: isValidURL(d)
    },
    twitter: {
      value: e || "",
      valid: isValidURL(e)
    },
    linkedIn: {
      value: f || "",
      valid: isValidURL(f)
    },
    other: {
      value: g || "",
      valid: isValidURL(g)
    }
  };
}

function getSocialProfilesFromState(a, b) {
  return Object.keys((0, _lodash2["default"])(a, "editingSocial")).reduce(function (c, d) {
    return b && !b.includes(d) ? c : _objectSpread(_objectSpread({}, c), {}, (0, _defineProperty2["default"])({}, d, a[d].value));
  }, {});
}

var LinkSocialButton = function (a) {
  function b(a) {
    var d;
    return (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), d.onUpdateField = (0, _lodash["default"])(function (a) {
      return function (b) {
        var c = b.target.value;
        d.setState((0, _defineProperty2["default"])({}, a, {
          value: c,
          valid: isValidURL(c)
        }));
      };
    }), d.hasInvalidField = (0, _memoizeOne["default"])(function (a) {
      var b = Object.values(a);
      return b.some(function (a) {
        return !a.valid;
      });
    }), d.onSave = function () {
      var a = d.props,
          b = a.onSave,
          c = a.allowedSocialTypes;
      b(getSocialProfilesFromState(d.state, c));
    }, d.getIcon = function (a, b) {
      var c = b.socialType,
          e = d.props,
          f = e.allowedSocialTypes,
          g = e.socialProfiles;
      return f && f.length && !f.some(function (a) {
        return a === c;
      }) ? null : _react["default"].createElement(_uiKit.Icon, {
        name: a,
        className: (0, _classnames["default"])("social-icon", "social-icon-".concat(c.toLowerCase()), {
          "social-icon--highlighted": g[c]
        }),
        color: "white",
        size: 17
      });
    }, d.toggleModal = function () {
      var a = d.props.socialProfiles;
      d.setState(function (b) {
        var c = b.editingSocial;
        return _objectSpread({
          editingSocial: !c
        }, getInitialState({
          socialProfiles: a
        }));
      });
    }, d.state = _objectSpread({
      editingSocial: !1
    }, getInitialState(a)), d;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "render",
    value: function render() {
      var a = this.state,
          b = a.editingSocial,
          c = (0, _objectWithoutProperties2["default"])(a, ["editingSocial"]),
          d = this.props,
          e = d.hideLabel,
          f = d.modalTitle,
          g = d.modalDescription,
          h = d.buttonTitle,
          i = d.allowedSocialTypes,
          j = d.disabled;
      return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_uiKit.FormModal, {
        key: "social-inputs-modal",
        visible: b,
        onClose: this.toggleModal,
        title: f,
        subtitle: g,
        onSave: this.onSave,
        saveDisabled: this.hasInvalidField(c)
      }, _react["default"].createElement(_SocialInputs["default"], {
        socialProfiles: c,
        onUpdateField: this.onUpdateField,
        allowedSocialTypes: i,
        isValidURL: isValidURL,
        disabled: j
      })), _react["default"].createElement(_uiKit.LabelWrapper, {
        label: e ? void 0 : h,
        notFullWidth: !0,
        className: "link-social-button"
      }, _react["default"].createElement(_uiKit.Button, {
        type: "TERTIARY",
        className: "link-social-button__button",
        onClick: this.toggleModal,
        key: "link-social-button"
      }, _react["default"].createElement("div", {
        className: "link-social-button__button__icons"
      }, this.getIcon("web", {
        socialType: "website"
      }), this.getIcon("facebook", {
        socialType: "facebook"
      }), this.getIcon("twitter", {
        socialType: "twitter"
      }), this.getIcon("linkedin", {
        socialType: "linkedIn"
      }), this.getIcon("options", {
        socialType: "other"
      })))));
    }
  }]), b;
}(_react.Component);

exports["default"] = LinkSocialButton, LinkSocialButton.defaultProps = {
  socialProfiles: {},
  hideLabel: !1,
  modalTitle: "Link Social Profiles",
  buttonTitle: "Link Social Profiles"
};